import { UserManagement } from '@/components/admin/users/UserManagement';
import { ErrorsManager } from '@/components/admin/ErrorsManager';
import { BillingManager } from '@/components/admin/BillingManager';
import { EmailManager } from '@/components/admin/EmailManager';
import { AIPromptsManager } from '@/components/admin/AIPromptsManager';
import { SystemManager } from '@/components/admin/SystemManager';
import { ReviewsManager } from '@/components/admin/ReviewsManager';
import { RevenueManager } from '@/components/admin/RevenueManager';
import { AdminLayout, useAdminSection } from '@/components/admin/AdminLayout';

export default function Admin() {
  const [active, setActive] = useAdminSection('users');

  const renderSection = () => {
    switch (active) {
      case 'users':
        return <UserManagement />;
      case 'reviews':
        return <ReviewsManager />;
      case 'revenue':
        return <RevenueManager />;
      case 'errors':
        return <ErrorsManager />;
      case 'email':
        return <EmailManager />;
      case 'billing':
        return <BillingManager />;
      case 'ai':
        return <AIPromptsManager />;
      case 'system':
        return <SystemManager />;
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen flex flex-col app-surface">
      <AdminLayout active={active} onChange={setActive}>
        {renderSection()}
      </AdminLayout>
    </div>
  );
}
